import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets scroll to the top on route change.
 *
 * The in-app shell scrolls inside `<main id="app-main" class="overflow-y-auto">`,
 * NOT the window. React Router 7 has no built-in scroll restoration, and a plain
 * `window.scrollTo` misses an inner scroll container — so without this a freshly
 * navigated page stays stuck at the previous tab's scroll offset (looks "partially
 * scrolled"). Reset both the inner container and the window to cover every layout.
 *
 * Skips hash navigations so in-page anchor links (e.g. `/#themes`) still scroll to
 * their target — that case is handled by useScrollToHash on the marketing layout.
 */
export function ScrollReset() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    document.getElementById('app-main')?.scrollTo({ top: 0, left: 0 })
    window.scrollTo({ top: 0, left: 0 })
  }, [pathname, hash])

  return null
}
